// The six KPI tiles (iOS StatTile in TodayKPIStrip / ReportKPIGrid): Visits, Contacts (+ contact rate),
// Appointments, New stores, Won (+ revenue) and Open pipeline (+ weighted). Each opens the Stores list with the
// matching filter when there is one (dashboardModel.storeLinks).

import { CalendarClock, ChartColumnBig, CirclePlus, Footprints, Handshake, Trophy, type LucideIcon } from 'lucide-react';
import { KpiTile } from '@/ui';
import type { KpiId, KpiTileModel } from './dashboardModel';

const KPI_ICONS: Readonly<Record<KpiId, LucideIcon>> = {
  visits: Footprints,
  contacts: Handshake,
  appointments: CalendarClock,
  newStores: CirclePlus,
  won: Trophy,
  pipeline: ChartColumnBig,
};

export function KpiGrid({ tiles, loading = false, label }: { tiles: readonly KpiTileModel[]; loading?: boolean; label: string }) {
  return (
    <section aria-label={label} aria-busy={loading || undefined}>
      <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3 2xl:grid-cols-6">
        {tiles.map((t) => {
          const Icon = KPI_ICONS[t.id];
          return (
            <li key={t.id} className="flex min-w-0">
              <KpiTile
                label={t.label}
                value={t.value}
                sub={t.sub}
                icon={<Icon />}
                color={t.color}
                to={t.href}
                loading={loading}
                className="w-full"
              />
            </li>
          );
        })}
      </ul>
    </section>
  );
}
